
import { provideRoutes } from '@angular/router';

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  name: 'prd',
  url_login: 'https://portal-bff.own.financial/amplus-core',
  url_server: 'https://portal-bff.own.financial/amplus-core/services',
  url_tx: '10.1.140.20',
  port_tx: '20002',
  portalVersion: '2.2.3',
  recaptcha: {
    siteKey: '6LdITqAqAAAAABHLCOQr0EQgafcK71-SXlPd1rYu', //não alterar
  },
  URL: {
		IP_USUARIO: 'https://api.ipify.org/?format=json',
	},
  blip_key: 'dmFsZWNhcmRyb3V0ZXJobWw6NzFiNWE0YzQtMWRhMS00ZDZjLWE5OGYtZWNhZDc3MDRjZjQz',
  blip_url: 'https://valecard.chat.blip.ai/'
};
